import { Link } from 'react-router-dom'

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 40%, #16213e 70%, #0f3460 100%)' }}>
      {/* Hero Section */}
      <div className="relative flex-1 flex flex-col">
        {/* Overlay pattern */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.05) 35px, rgba(255,255,255,.05) 70px)',
        }} />

        {/* Flags top-right */}
        <div className="relative z-10 flex justify-end items-center gap-3 px-6 pt-4">
          {/* Bandeira do Brasil - SVG inline */}
          <div className="flex flex-col items-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" className="w-10 h-7 rounded shadow-lg">
              <rect width="20" height="14" fill="#009b3a"/>
              <polygon points="10,1 19,7 10,13 1,7" fill="#fedf00"/>
              <circle cx="10" cy="7" r="3.5" fill="#002776"/>
              <path d="M6.8,6.2 Q10,5 13.2,6.2" stroke="#fff" strokeWidth="0.6" fill="none"/>
            </svg>
            <span className="text-compumaq-textoSuave text-xs">Brasil</span>
          </div>
          {/* Bandeira de Mato Grosso */}
          <div className="flex flex-col items-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" className="w-10 h-7 rounded shadow-lg">
              <rect width="20" height="14" fill="#00247d"/>
              <polygon points="10,1.5 18,7 10,12.5 2,7" fill="#fff"/>
              <circle cx="10" cy="7" r="3.2" fill="#006b3f"/>
              <polygon points="10,4.2 10.6,6.1 12.5,6.1 11,7.2 11.5,9.2 10,8 8.5,9.2 9,7.2 7.5,6.1 9.4,6.1" fill="#ffd700"/>
            </svg>
            <span className="text-compumaq-textoSuave text-xs">Mato Grosso</span>
          </div>
        </div>

        {/* Main content */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 py-8 text-center">
          {/* Logo do Clube de Tiro Águia */}
          <div className="mb-6">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-full border-4 border-yellow-500 shadow-2xl mx-auto overflow-hidden">
              <img
                src="/logo-clube.jpeg"
                alt="Clube de Tiro Águia"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Title */}
          <div className="mb-2 flex flex-col items-center gap-2">
            <span className="inline-block bg-yellow-500 text-compumaq-texto text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest">
              Clube de Tiro Águia
            </span>
            <span className="inline-block bg-compumaq-dourado text-compumaq-texto text-sm font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-lg shadow-compumaq-dourado/40">
              2&ordf; ETAPA
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-3 leading-tight mt-3">
            Campeonato{' '}
            <span className="text-yellow-400">2026</span>
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-yellow-300 mb-2">Águia</h2>

          {/* Date */}
          <div className="flex items-center gap-3 mb-3">
            <div className="h-px w-12 bg-yellow-500/50" />
            <p className="text-compumaq-textoSuave text-lg font-medium tracking-wide">
              29/08/2026 &mdash; 30/08/2026
            </p>
            <div className="h-px w-12 bg-yellow-500/50" />
          </div>

          {/* Local do evento */}
          <div className="mb-6 flex items-center gap-2 text-compumaq-textoSuave text-sm">
            <svg className="w-4 h-4 text-yellow-500 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            <span>Clube de Tiro Águia &mdash; Nova Xavantina, MT</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md mb-4">
            <Link
              to="/inscricao-publica"
              className="flex-1 bg-yellow-500 hover:bg-yellow-400 text-compumaq-texto font-bold py-4 px-6 rounded-xl text-center transition-all duration-200 shadow-lg hover:shadow-yellow-500/30 hover:scale-105 text-sm md:text-base"
            >
              Clique aqui para fazer sua inscrição
            </Link>
            <Link
              to="/login"
              className="flex-1 bg-transparent hover:bg-compumaq-pretoSuave/10 text-white font-semibold py-4 px-6 rounded-xl text-center transition-all duration-200 border border-white/30 hover:border-white/60 text-sm md:text-base"
            >
              Entrar no Sistema
            </Link>
          </div>

          {/* Secondary Buttons: Inscritos + Resultados + TV */}
          <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
            <Link
              to="/inscritos"
              className="flex-1 flex items-center justify-center gap-2 bg-compumaq-pretoSuave/10 hover:bg-compumaq-pretoSuave/20 text-white font-semibold py-3 px-5 rounded-xl text-center transition-all duration-200 border border-white/20 hover:border-white/40 text-sm"
            >
              <svg className="w-4 h-4 text-yellow-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Visualizar Inscritos
            </Link>
            <Link
              to="/resultados-publico"
              className="flex-1 flex items-center justify-center gap-2 bg-compumaq-pretoSuave/10 hover:bg-compumaq-pretoSuave/20 text-white font-semibold py-3 px-5 rounded-xl text-center transition-all duration-200 border border-white/20 hover:border-white/40 text-sm"
            >
              <svg className="w-4 h-4 text-yellow-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Acompanhar Resultados
            </Link>
          </div>
          <div className="w-full max-w-md mt-3">
            <Link
              to="/tv"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-2 bg-compumaq-pretoSuave/5 hover:bg-compumaq-pretoSuave/15 text-white/70 hover:text-white font-semibold py-2.5 px-5 rounded-xl text-center transition-all duration-200 border border-white/10 hover:border-white/30 text-xs uppercase tracking-wide"
            >
              <svg className="w-4 h-4 text-yellow-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <rect x="2" y="4" width="20" height="14" rx="2" strokeLinecap="round" strokeLinejoin="round" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 21h8M12 18v3" />
              </svg>
              Abrir Painel de TV
            </Link>
          </div>
        </div>
      </div>

      {/* Premiacoes Section */}
      <div className="relative z-10 border-t border-yellow-500/30 bg-black/20 backdrop-blur-sm py-10 px-4">
        <p className="text-center text-yellow-400 text-xs uppercase tracking-widest mb-2 font-bold">
          Premiacoes
        </p>
        <h2 className="text-center text-white font-black text-2xl mb-8">
          Premios do Campeonato <span className="text-yellow-400">2026</span> &mdash; <span className="text-compumaq-textoSuave">2&ordf; Etapa</span>
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {[
            { img: '/premios/carabina-pressao.jpeg', label: 'Carabina de Pressao 5.5mm' },
            { img: '/premios/carabina-8122.jpeg', label: 'Carabina 8122' },
            { img: '/premios/carabina-pcp-55.jpeg', label: 'Carabina PCP 5.5mm' },
            { img: '/premios/municao-22.jpeg', label: 'Municao .22 LR' },
            { img: '/premios/municao-38.jpeg', label: 'Municao .38' },
            { img: '/premios/municao-fuzil.jpeg', label: 'Municao .308 WIN' },
          ].map((premio) => (
            <div
              key={premio.label}
              className="flex flex-col items-center gap-2 bg-compumaq-pretoSuave/5 border border-yellow-500/20 rounded-2xl p-4 hover:border-yellow-500/50 hover:bg-compumaq-pretoSuave/10 transition-all"
            >
              <div className="w-full aspect-square rounded-xl bg-black/30 overflow-hidden">
                <img
                  src={premio.img}
                  alt={premio.label}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <p className="text-yellow-300 text-xs font-semibold text-center leading-tight">{premio.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Endereco para Guia de Trafego */}
      <div className="relative z-10 border-t border-yellow-500/30 bg-yellow-950/20 backdrop-blur-sm py-6 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-10 h-10 rounded-full bg-yellow-500/20 flex items-center justify-center mt-0.5">
              <svg className="w-5 h-5 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-yellow-400 font-bold text-sm uppercase tracking-wider mb-2">
                Endereco para Emissao de Guia de Trafego de Armas
              </h3>
              <p className="text-white font-semibold text-base">AGUIA ESCOLA DE TREINAMENTO DE TIRO LTDA</p>
              <p className="text-compumaq-textoSuave text-sm mt-0.5">CNPJ: 45.022.992/0001-96</p>
              <div className="mt-2 space-y-0.5 text-compumaq-textoSuave text-sm">
                <p>AV AMAZONA, 888 - SETOR NOVA BRASILIA, TONEOT</p>
                <p className="text-compumaq-textoSuave">ESTANDE NA EST MUNICIPAL NX-400 SENTIDO RIBEIRAO ANTARTICO, ZONA RURAL</p>
                <p>CEP: 79690-000 &mdash; NOVA XAVANTINA - MT</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sponsors Section */}
      <div className="relative z-10 border-t border-white/10 bg-black/30 backdrop-blur-sm py-8 px-4">
        <p className="text-center text-compumaq-textoSuave text-xs uppercase tracking-widest mb-6 font-semibold">
          Patrocinadores
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 max-w-3xl mx-auto">
          {/* Compumaq Tecnologia */}
          <div className="flex flex-col items-center gap-2 opacity-80 hover:opacity-100 transition-opacity">
            <div className="bg-compumaq-pretoSuave rounded-xl p-3 shadow-md border border-white/20 flex items-center justify-center" style={{ width: 140, height: 80 }}>
              <img
                src="/patrocinadores/compumaq.png"
                alt="Compumaq Tecnologia"
                className="max-w-full max-h-full object-contain"
                style={{ maxWidth: 130, maxHeight: 70 }}
              />
            </div>
            <span className="text-compumaq-textoSuave text-xs font-medium">Compumaq Tecnologia</span>
          </div>

          {/* Parreira Despachante de Armas */}
          <div className="flex flex-col items-center gap-2 opacity-80 hover:opacity-100 transition-opacity">
            <div className="bg-compumaq-pretoSuave rounded-xl p-3 shadow-md border border-white/20 flex items-center justify-center" style={{ width: 140, height: 80 }}>
              <img
                src="/patrocinadores/parreira.jpeg"
                alt="Parreira Despachante de Armas"
                className="max-w-full max-h-full object-contain"
                style={{ maxWidth: 130, maxHeight: 70 }}
              />
            </div>
            <span className="text-compumaq-textoSuave text-xs font-medium">Parreira Despachante de Armas</span>
          </div>

          {/* Precision Esporte Lazer e Caca */}
          <div className="flex flex-col items-center gap-2 opacity-80 hover:opacity-100 transition-opacity">
            <div className="bg-compumaq-pretoSuave rounded-xl p-3 shadow-md border border-white/20 flex items-center justify-center" style={{ width: 140, height: 80 }}>
              <img
                src="/patrocinadores/precision.png"
                alt="Precision Esporte Lazer e Caca"
                className="max-w-full max-h-full object-contain"
                style={{ maxWidth: 130, maxHeight: 70 }}
              />
            </div>
            <span className="text-compumaq-textoSuave text-xs font-medium">Precision Esporte Lazer e Caca</span>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-compumaq-textoSuave text-xs mt-8">
          &copy; 2026 Clube de Tiro Águia &mdash; Sistema de Gestao de Campeonatos
        </p>
      </div>
    </div>
  )
}
